x
<template>
    <div v-if="component_done_loading" class="col-xs-12 right-container">
        <div class="form-div">
            <kr-panel>
                <template #title>
                    <h1>Edit Teacher Profile</h1>
                </template>
                <template #content>
                    <teacher-form :form="form" />
                    <div class="flex gap10" :class="{ 'marginLeft140px width50': !isMobileView }">
                        <router-link
                            v-if="!isFromAccount"
                            v-slot="{ navigate }"
                            :to="{
                                name: 'teachers.view',
                                params: $route.params.id,
                            }"
                            custom
                        >
                            <button class="btn btn-default margin0" @click="navigate">Cancel</button>
                        </router-link>
                        <router-link
                            v-else
                            v-slot="{ navigate }"
                            :to="{
                                name: 'accounts.teachers.view',
                                params: $route.params.id,
                                query: { tab: 'teachers' },
                            }"
                            custom
                        >
                            <button class="btn btn-default margin0" @click="navigate">Cancel</button>
                        </router-link>
                        <button class="btn btn-success margin0" :disabled="!canSend ? true : undefined" @click="submit()">
                            <i class="fa fa-check marginRight8" aria-hidden="true"></i>Update
                        </button>
                    </div>
                </template>
            </kr-panel>
        </div>
    </div>
</template>
<script setup>
import { ref, onMounted, computed } from 'vue';
import KrForm from '../../../components/forms/form';
import KrAuth from '../../../components/auth/auth';

import { useRoute, useRouter } from 'vue-router';

import TeacherForm from './form-partials/partial.teacher.vue';

const route = useRoute();
const router = useRouter();
const auth = new KrAuth();

const component_done_loading = ref(false);
const isSetAccount = ref(true);
const isFromAccount = ref(false);
const accounts = ref([]);
const teacher = ref({});
const form = new KrForm({
    fields: {
        avatar: '',
        firstname: '',
        lastname: '',
        displayName: '',
        email: '',
        roleId: 'default!:3',
        password: 'sendNull!:false',
        password_confirmation: 'sendNull!:false',
        identity: '',
        canAddTeacher: '',
        canViewQuestionBank: '',
        academicDiscipline: 'sendNull!:false',
        jobTitle: 'sendNull!:false',
        level1DepartmentId: '',
        level2DepartmentId: '',
    },
    props: {},
    urls: {
        patch: `/teachers/${route.params.id}`,
    },
});

const canSend = computed(() => {
    if (
        (!form.errors.any() && form.model.email && form.model.firstname && form.model.lastname && form.model.password && form.model.password_confirmation) ||
        !form.model.password
    ) {
        return true;
    }
    return false;
});

const fetch = () => {
    let url = `/teachers/${route.params.id}`;
    if (route.name == 'accounts.teachers.edit') {
        url = `/users/${route.params.id}`;
    }
    axios.get(url).then(function (user) {
        teacher.value = user.data.data;
        form.setModel(user.data.data);
        form.model.level1DepartmentId = user.data.data.department?.level1?.id;
        form.model.level2DepartmentId = user.data.data.department?.level2?.id;
        breadCrumbTitle(user.data.data);
        component_done_loading.value = true;
    });
};

const submit = () => {
    form.model.displayName = form.model.firstname + (form.model.lastname ? ' ' + form.model.lastname : '');
    form.patch().then(function (response) {
        if (!response.krFormError) {
            if (!isFromAccount.value) {
                router.push({
                    name: 'teachers.view',
                    params: { id: route.params.id },
                });
            } else {
                router.push({
                    name: 'accounts.teachers.view',
                    params: { id: route.params.id },
                    query: { tab: 'teachers' },
                });
            }
        }
    });
};

const breadCrumbTitle = (user) => {
    if (route.name == 'accounts.teachers.edit') {
        Events.fire('topbar_update', {
            breadcrumb: [
                { name: 'Home' },
                {
                    name: 'Account',
                    link: 'accounts.view',
                    params: { id: user.account.uuid },
                    query: { tab: 'teachers' },
                },
                { name: teacher.value.displayName, link: 'accounts.teachers.view', params: { id: route.params.id } },
                { name: 'Edit Teacher' },
            ],
        });
    } else {
        Events.fire('topbar_update', {
            breadcrumb: [
                { name: 'Home' },
                { name: 'People', link: 'people.index', query: { tab: 'teachers' } },
                {
                    name: user.displayName,
                    link: 'teachers.view',
                    params: { id: user.uuid },
                },
                { name: 'Edit Teacher' },
            ],
        });
    }
};

onMounted(() => {
    if (route.name == 'accounts.teachers.edit') {
        isFromAccount.value = true;
    }

    fetch();
});
</script>
